import { Image } from 'expo-image';
import { useState } from 'react';
import { View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { AddCarsModal } from '@/components/cars/add-cars-modal';
import { useTrackMetaEvent } from '@/core/hooks/use-track-meta-event';
import { Button, Text } from '@/ui';

type NoCarsEmptyStateProps = {
  title: string;
  body: string;
  ctaText: string;
  illustration?: React.ReactNode;
  onPress?: () => void;
  redirectPath?: string;
};

export function NoCarsEmptyState({
  title,
  body,
  ctaText,
  illustration,
  onPress,
  redirectPath,
}: NoCarsEmptyStateProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [showAddCarsModal, setShowAddCarsModal] = useState(false);
  const trackMetaEvent = useTrackMetaEvent();
  const fallbackCarImage =
    UnistylesRuntime.themeName === 'dark'
      ? require('../../../public/images/cars/fallback-car-dark.png')
      : require('../../../public/images/cars/fallback-car-light.png');

  return (
    <View style={styles.outerContainer}>
      <View style={styles.container}>
        {illustration ? (
          illustration
        ) : (
          <View>
            <Image
              source={fallbackCarImage}
              style={{
                width: '100%',
                aspectRatio: 16 / 9,
              }}
              contentFit="cover"
            />
          </View>
        )}

        <View style={{ alignItems: 'center', gap: 8 }}>
          <Text type="title2">{title}</Text>

          <Text
            type="bodyRegular"
            style={[{ color: theme.colors.text.secondary }, styles.bodyText]}
          >
            {body}
          </Text>
        </View>

        <View>
          <Button
            text={ctaText}
            type="primary"
            onPress={() => {
              if (redirectPath) {
                trackMetaEvent('Lead');
                setShowAddCarsModal(true);
                return;
              }
              onPress?.();
            }}
          />
        </View>
      </View>

      {redirectPath ? (
        <AddCarsModal
          visible={showAddCarsModal}
          onClose={() => setShowAddCarsModal(false)}
          redirectPath={redirectPath}
        />
      ) : null}
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  outerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.background_1,
  },
  bodyText: {
    textAlign: 'center',
    width: {
      xs: undefined,
      md: 620,
    },
    paddingHorizontal: {
      xs: 40,
      md: 0,
    },
  },
  container: {
    flexGrow: 1,
    gap: 16,
    padding: 16,
    justifyContent: 'center',
    width: {
      xs: 'auto',
      md: 400,
    },
  },
}));
